export default class Accordion {
  constructor(accordion, index) {
    this.accordion = accordion
    this.index = index

    this.title = this.accordion.querySelector('.accordion-title')
    this.body = this.accordion.querySelector('.accordion-hidden-section')
    this.accordionContent = this.body.querySelector('.accordion-content')

    this.clickAction = this.clickAction.bind(this)

    this.init()
  }

  init() {
    this.reset()
    this.addListeners()
  }

  addListeners() {
    this.title.addEventListener('click', this.clickAction)
  }

  clickAction(e) {
    if (!this.accordion.classList.contains('open')) {
      Accordion.items.forEach((elem) => {
        elem.reset()
      })
      this.accordion.classList.toggle('open')
      this.body.style.height = this.accordionContent.offsetHeight + 'px'
    }
  }

  reset() {
    this.accordion.classList.remove('open')
    this.body.style.height = '0px'
  }

  destroy() {
    this.title.removeEventListener('click', this.clickAction)
    this.reset()
  }

  static resetAll() {
    setTimeout(() => {
      Accordion.items.forEach((elem) => {
        elem.reset()
      })
    }, 500)
  }

  static destroyAll() {
    Accordion.items.forEach((elem) => {
      elem.destroy()
    })
  }

  static init() {
    Accordion.items = Array.from(document.querySelectorAll('.accordion')).map(
      (accordion, index) => new Accordion(accordion, index)
    )
    var first_elm = document.querySelector('.accordion .accordion-title:first-child')
    if( first_elm ) {
      setTimeout(() => {
        first_elm.click();
      }, 500)
    }
    
  }
}
